export enum NonogramCell {
    UNSET = 0,
    SET = 1,
    UNKNOWN = 2
}


// WEBPACK FOOTER //
// ./src/models/nonogram-cell.ts